export * from "./iframeAllow.js";
export * from "./getLink.js";
export * from "./getMetaContent.js";
export * from "./popup.js";
export * from "./registerMse.js";
export * from "./viewPDF.js";

export const DEFAULT_RATIO = 16 / 9;
